<template>
    <div>
        <LabelList :type="type"></LabelList>
    </div>
</template>

<script>
    import LabelList from './components/labelList';

    export default {
        name: "Character",
        components: {
            LabelList
        },
        data() {
            return {
                type:"PEOPLE_LABEL"
            };
        }
    }
</script>

<style lang="less" scoped>

</style>